<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { onMount } from 'svelte';
  import {
    AppState,
    SetIconsBackground,
    SetNotification
  } from '../../../etc/stores';
  import MessagePopup from '../../misc/MessagePopup.svelte';
  import ThemedIcon from '../../misc/ThemedIcon.svelte';
  import Button from '../../form/Button.svelte';
  import Link from '../../misc/Link.svelte';
  import Close from '../../icons/Close.svelte';
  import Analytics from '../../../services/analytics';
  import PoweredBy from '../../misc/PoweredBy.svelte';
  import { replaceVariables } from '../../../i18n';
  import Heading from '../../typography/Heading.svelte';
  import Text from '../../typography/Text.svelte';
  import WelcomeCoinPreviouslyClaimedIcon from '../../icons/WelcomeCoinPreviouslyClaimedIcon.svelte';

  const t = (text: string, values: any = {}) => {
    return replaceVariables(
      $_(`welcome_coin_previously_claimed_popup.${text}`),
      values
    );
  };

  const closeMessage = () => {
    SetNotification('');
  };

  const goToWallet = () => {
    AppState.update(state => ({
      ...state,
      website: {
        ...state.website,
        popoverOpen: true,
        popoverRouteOnOpen: {
          route: '/dashboard'
        }
      }
    }));

    closeMessage();
  };

  const continueBrowsing = () => {
    closeMessage();
  };

  onMount(() => {
    SetIconsBackground('light-without-background');
    Analytics.logEvent('claim-error-already-get', 'free-coins-state');
  });
</script>

<MessagePopup>
  <div class="welcome-coin-previously-claimed--wrapper">
    <div class="welcome-coin-previously-claimed--close" on:click={closeMessage}>
      <ThemedIcon>
        <Close />
      </ThemedIcon>
    </div>
    <WelcomeCoinPreviouslyClaimedIcon />
    <div class="welcome-coin-previously-claimed--content">
      <Heading type="h2" textAlign="center">
        {t('title')}
      </Heading>
      <Text type="default" textAlign="center">
        {t('description', { firstName: $AppState.customer.name })}
      </Text>
    </div>
    <Button label={t('btn')} on:click={continueBrowsing} />
    <div class="welcome-coin-previously-claimed--link">
      <Link fontSize="14px" lineHeight="20px" on:click={goToWallet}>
        {t('link')}
      </Link>
    </div>
    <PoweredBy />
  </div>
</MessagePopup>

<style lang="scss">
  @use './styles.scss' as *;

  .welcome-coin-previously-claimed {
    &--wrapper {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      width: 100%;
      padding: 24px 24px 0;
      box-sizing: border-box;
    }

    &--content {
      :global(h2) {
        margin-top: 16px !important;
      }

      :global(p) {
        margin-top: 16px !important;
        margin-bottom: 24px !important;
      }
    }

    &--link {
      margin: 24px 0;
    }

    &--close {
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;
    }
  }
</style>
